function format(cpnj) {
  if (!cpnj) return '';
  let value = '';
  value += cpnj.substring(0, 2);
  value += '.';
  value += cpnj.substring(2, 5);
  value += '.';
  value += cpnj.substring(5, 8);
  value += '/';
  value += cpnj.substring(8, 12);
  value += '-';
  value += cpnj.substring(12, cpnj.length);
  return value;
}

export default {
  format,
};



// WEBPACK FOOTER //
// ./src/mixins/cnpj-mixin.js